import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { Box } from '../../../layouts';
import wavesEffect from '../wavesEffect';

const SkeletonBox = styled(Box, { shouldForwardProp })(
  css({
    backgroundColor: 'neutral.40',
    position: 'relative',
    overflow: 'hidden',
  }),
  wavesEffect
);

export default SkeletonBox;
